// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyProfileView--userImg {
  display: flex;
  justify-content: center;
}
.MyProfileView--userImg img {
  margin-top: -5rem;
  height: 88px;
  width: 88pxpx;
  border-radius: 88px;
}

.MyProfileView--content {
  text-align: center;
}
.MyProfileView--content .text {
  padding-block: 2.5rem;
}
.MyProfileView--content .text p:first-child {
  font-size: 18px;
  font-weight: 600;
  line-height: 18.8px;
}
.MyProfileView--content .text p:nth-child(2) {
  font-size: 14px;
  color: #4c4c4c;
  line-height: 18.8px;
}
.MyProfileView--content .input-filed {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  text-align: left;
}
.MyProfileView--content .input-filed p {
  color: #333333;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
}
.MyProfileView--content .input-filed span {
  position: relative;
  bottom: 25px;
  background-color: white;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #4c4c4c;
}

.hr-dividerline {
  border-bottom: 1px solid #d9d9d9;
  margin-block: 3rem;
}

.MyProfileView--logout {
  margin-top: 2.5rem;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  display: flex;
  gap: 2rem;
  padding: 1rem;
}
.MyProfileView--logout p {
  align-self: center;
  font-size: 14px;
  font-weight: 700;
}

.forAddress,
.forEmail {
  padding: 16px 16px 20px 16px;
  border-radius: 12px;
  border: 1px solid #f2f2f2;
}

.chatBotIcon {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 64px;
  height: 64px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/MyProfileView/myprofileview.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;AACJ;AAAI;EACI,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAER;;AACA;EACI,kBAAA;AAEJ;AADI;EACI,qBAAA;AAGR;AAFQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAIZ;AAFQ;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AAIZ;AADI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAGR;AAFQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAIZ;AAFQ;EACI,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAIZ;;AAAA;EACI,gCAAA;EACA,kBAAA;AAGJ;;AADA;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AAIJ;AAHI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AAKR;;AAFA;;EAEI,4BAAA;EACA,mBAAA;EACA,yBAAA;AAKJ;;AAAA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AAGJ","sourcesContent":[".MyProfileView--userImg {\n    display: flex;\n    justify-content: center;\n    img {\n        margin-top: -5rem;\n        height: 88px;\n        width: 88pxpx;\n        border-radius: 88px;\n    }\n}\n.MyProfileView--content {\n    text-align: center;\n    .text {\n        padding-block: 2.5rem;\n        p:first-child {\n            font-size: 18px;\n            font-weight: 600;\n            line-height: 18.8px;\n        }\n        p:nth-child(2) {\n            font-size: 14px;\n            color: #4c4c4c;\n            line-height: 18.8px;\n        }\n    }\n    .input-filed {\n        display: flex;\n        flex-direction: column;\n        gap: 2rem;\n        text-align: left;\n        p {\n            color: #333333;\n            font-size: 14px;\n            font-weight: 300;\n            line-height: 18px;\n            letter-spacing: 0em;\n            text-align: left;\n        }\n        span {\n            position: relative;\n            bottom: 25px;\n            background-color: white;\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 15px;\n            letter-spacing: 0em;\n            text-align: left;\n            color: #4c4c4c;\n        }\n    }\n}\n.hr-dividerline {\n    border-bottom: 1px solid #d9d9d9;\n    margin-block: 3rem;\n}\n.MyProfileView--logout {\n    margin-top: 2.5rem;\n    border: 1px solid #d9d9d9;\n    border-radius: 12px;\n    display: flex;\n    gap: 2rem;\n    padding: 1rem;\n    p {\n        align-self: center;\n        font-size: 14px;\n        font-weight: 700;\n    }\n}\n.forAddress,\n.forEmail {\n    padding: 16px 16px 20px 16px;\n    border-radius: 12px;\n    border: 1px solid #f2f2f2;\n\n    // gap: 8px\n}\n\n.chatBotIcon {\n    position: fixed;\n    bottom: 80px;\n    right: 20px;\n    width: 64px;\n    height: 64px;\n    background: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
